// Thin wrapper around window.gtag (loaded via the script tag in public/index.html)

export const trackPageview = (path) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (action, params = {}) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', action, params);
};
